import { render, staticRenderFns } from "./PrivacyStatementLayout.vue?vue&type=template&id=c2ca216e&"
import script from "./PrivacyStatementLayout.vue?vue&type=script&lang=js&"
export * from "./PrivacyStatementLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports